import { render, staticRenderFns } from "./userTransactions.vue?vue&type=template&id=4383c1f6"
import script from "./userTransactions.vue?vue&type=script&lang=js"
export * from "./userTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports